<template>
  <v-dialog
    :value="show"
    max-width="500px"
    @click:outside="closeDialog"
  >
    <!-- <v-card
      dark
      max-width="500px"
    >
      <v-card-text> -->
    <div style="display:flex; flex-direction:column; align-items:center; padding-top:10px; position:relative;">
      <img
        :src="img"
        style="width:100%; max-width:500px; border-radius:10px;"
      >
      <div style="position: absolute; bottom:10px; right:10px;">
        <v-icon
          large
          color="red"
          @click="download"
        >
          mdi-download
        </v-icon>
      </div>
    </div>
    <!-- </v-card-text>
    </v-card> -->
  </v-dialog>
</template>

<script>

export default {
  props: {
    show: Boolean,
    img: { type: String, default: '' }

  },
  emits: ['close'],
  data () {
    return {
      sh: ''
    }
  },
  watch: {
    show (val) {
      console.log(val)
      console.log(this.img)
    }
  },
  methods: {
    download () {
      window.open(this.img)
    },
    closeDialog () {
      this.$emit('close')
    }

  }
}
</script>

<style scoped>
.card{

    padding: 30px;
    width: 100%;
    max-width: 700px;
    border: solid 4px #f9d71c;
    border-radius: 10px;
}
.v-text-field input {
  color:black;
}

</style>